import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ApplicationDataService } from '../../../services/application.service';
import { CognitoUtil } from '../../../services/cognito.service';
import { Application } from '../../models/application';
import { Property } from '../../models/property';
import { ErrorService } from '../../../services/error.service';
import { AnalyticsService } from 'services/analytics.service';
import { environment } from 'environments/environment';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {
  errorMessage: string = null;
  applications: Application[] = [];
  draftStatusApplications: Application[] = [];
  submittedStatusApplications: Application[] = [];
  waitlistStatusApplications: Application[] = [];
  closedStatusApplications: Application[] = [];
  draftStatus: string = 'DRAFT';
  submittedStatuses: string[] = ['IN REVIEW', 'IN PROGRESS', 'APPROVED WITH CONDITIONS', 'APPROVED', 'APPROVED PENDING ID'];
  closedStatuses: string[] = ['CANCELED', 'CANCELED - NEW PROPERTY', 'CANCELED NO SIGNATURE', 'LEASED', 'DENIED'];
  waitliStatus: string = 'WAIT LIST';
  showApplicationTabs: boolean;
  isLoading: boolean;
  source: string = null;
  activeApplicationConfirmation: string;
  showDefaultApplicationConfirmation: boolean = false;
  waitlist: boolean;
  background: boolean;
  error: boolean;
  PrimaryApplicantName: String = '';
  selectedPropertyTitle: string;
  triconDomain = environment.triconDomain;
  public modelProperty: Property;
  public smartHomeLink: string = null;
  private sub: any;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private applicationService: ApplicationDataService,
    private cognitoUtil: CognitoUtil,
    private errorService: ErrorService,
    private readonly analyticsService: AnalyticsService) {
      this.analyticsService.track(
        'HRA Application',
        'Dashboard',
        'Start',
        'Start',
        '',
        this.additionalAnalyticsDetails());
    localStorage.removeItem('AddAdditionalApplicantKey');
    localStorage.removeItem('AddAdditionalApplicantName');
    localStorage.removeItem('PrimaryApplicant');
    localStorage.removeItem('CorrectStatus');

    let invitationID = localStorage.getItem('InvitationID');
    localStorage.removeItem('InvitationID');

    if (invitationID) {
      this.applicationService.getInvitationApplication(invitationID).subscribe(res => this.continueApplication(res), res => this.applicationService.handleError(res));
    }
    else {
      this.isLoading = true;
      this.applicationService.getApplications()
        .subscribe(res => this.onGetApplications(res), res => this.applicationService.handleError(res));
    }
  }

  private additionalAnalyticsDetails(): any {
    try {
      return { };
    } catch (error) {
      console.error(error);
      return {};
    }
  }

  async ngOnInit() {
    this.sub = this.route.params.subscribe(params => {
      this.source = params['source'];
      const property = JSON.parse(localStorage.getItem('SelectedProperty'));
      if (property != null) {
        this.modelProperty = property[0];
        this.selectedPropertyTitle = this.modelProperty.street;
      }

      if (this.source === 'payment') {
        this.applicationService.getActiveApplicationConfirmation(localStorage.getItem("RentalApplicationKey"))
          .subscribe(res => this.setActiveApplicationConfirmation(res), err => this.setDefaultApplicationConfirmation(err));
        this.applicationService.checkIfSmartHomeMarket(localStorage.getItem('RentalApplicationKey'))
          .subscribe(res => this.smartHomeLink = res);
      }

      if (this.source === 'waitlist') {
        this.waitlist = true;
      }

      if (this.source === 'background') {
        this.background = true;
        this.applicationService.getApplicationPrimaryApplicantName(localStorage.getItem('RentalApplicationKey'))
          .subscribe(res => this.PrimaryApplicantName = res, err => this.applicationService.handleError(err));
      }

      if (this.source === "error") {
        this.error = true;
        this.errorService.showError("An unexpected error has occurred. You can resume your application by selecting it above.")
      }

      if (this.source === "inviteError") {
        this.errorMessage = params['errmsg'];
        this.errorService.showError(this.errorMessage)
      }

      if (this.source === "SmartHomeAccessDenied") {
        this.errorMessage = "You do not currently have permission to access the Smart Home management section. If you believe this is in error, please contact support at (844) 874-2661";
        this.errorService.showError(this.errorMessage)
      }

      localStorage.removeItem('YardiKey');
      localStorage.removeItem('mfunitcode');
      localStorage.removeItem('hasRentableItems');
    });
  }

  setDefaultApplicationConfirmation(err) {
    this.showDefaultApplicationConfirmation = true;
  }

  setActiveApplicationConfirmation(confirmation: string) {
    if (confirmation != null) {
      this.activeApplicationConfirmation = confirmation;
    }
    else {
      this.showDefaultApplicationConfirmation = true;
    }
  }

  async onGetApplications(applications: Application[]) {
    this.applications = applications;
    var prop;

    for (const element of applications) {
      if (element.UnitCode != null) {
        // MF prop
        prop = await this.applicationService.getMFProperty(element.YardiKey, element.UnitCode).toPromise();
      }
      else {
        prop = await this.applicationService.getProperty(element.YardiKey).toPromise();
      }

      if (prop == null || prop.results == null || prop.results.length == 0) continue;

      element.PropViewCard = prop.results[0];
      element.PropViewCard.sqft = element.PropViewCard.sqft.toLocaleString();

      if ((prop.results[0].min_rent != null && prop.results[0].max_rent != null) && (prop.results[0].min_rent == prop.results[0].max_rent)) {
        element.PropViewCard.rent = prop.results[0].min_rent.toLocaleString().toLocaleString();
      }
      else if (prop.results[0].min_rent != null && prop.results[0].max_rent != null) {
        element.PropViewCard.rent = prop.results[0].min_rent.toLocaleString() + '-$'+ prop.results[0].max_rent.toLocaleString()
      }
      else {
        element.PropViewCard.rent = element.PropViewCard?.rent?.toLocaleString();
      }

      element.RentalAppStatus = element.RentalAppStatus.toUpperCase();

      if (element.RentAmount && element.RentalAppStatus != 'DRAFT' && element.RentalAppStatus != 'WAIT LIST') {
        element.PropViewCard.rent = `${element.RentAmount}`;
      }

      if (this.draftStatus === element.RentalAppStatus) {
        this.draftStatusApplications.push(element);
        this.showApplicationTabs = true;
      } else if (this.submittedStatuses.includes(element.RentalAppStatus)) {
        this.submittedStatusApplications.push(element);
        this.showApplicationTabs = true;
      } else if (this.closedStatuses.includes(element.RentalAppStatus)) {
        this.closedStatusApplications.push(element);
        this.showApplicationTabs = true;
      } else if (this.waitliStatus === element.RentalAppStatus) {
        this.waitlistStatusApplications.push(element);
        this.showApplicationTabs = true;
      }
    }

    let addApplication = new Application();
    addApplication.Property = { AddressLine1: 'Apply Now', City: 'Interested in applying for a Tricon rental home?', PropertyPhase: '' }
    addApplication.RentalAppStatus = 'FIND A HOME';
    this.applications.push(addApplication);

    // If not empty, sort newest to oldest and push the add property card after.
    if (this.draftStatusApplications.length) {
      this.draftStatusApplications.sort((a,b) => b.RentalApplicationKey - a.RentalApplicationKey);
      this.draftStatusApplications.push(addApplication);
    }
    if (this.submittedStatusApplications.length) {
      this.submittedStatusApplications.sort((a,b) => b.RentalApplicationKey - a.RentalApplicationKey);
      this.submittedStatusApplications.push(addApplication);
    }
    if (this.closedStatusApplications.length) {
      this.closedStatusApplications.sort((a,b) => b.RentalApplicationKey - a.RentalApplicationKey);
      this.closedStatusApplications.push(addApplication);
    }
    if (this.waitlistStatusApplications.length) {
      this.waitlistStatusApplications.sort((a,b) => b.RentalApplicationKey - a.RentalApplicationKey);
      this.waitlistStatusApplications.push(addApplication);
    }

    this.isLoading = false;
  }

  async continueApplication(application: Application) {
    if (application.RentalApplicationKey !== 0) {
      localStorage.setItem('YardiKey', application.YardiKey);
      localStorage.removeItem('SelectedProperty');
      localStorage.removeItem('mfunitcode');
      localStorage.removeItem('hasRentableItems');
      localStorage.setItem('RentalApplicationKey', application.RentalApplicationKey.toString());

      if (application.UnitCode != null) {
        localStorage.setItem('mfunitcode', application.UnitCode);
        // MF prop
        this.applicationService.getMFProperty(application.YardiKey, application.UnitCode)
          .subscribe(res => this.onPropertyListCheck(res.results, application), err => this.applicationService.handleError(err));
      }
      else {
        this.applicationService.getProperty(application.YardiKey)
          .subscribe(res => this.onPropertyListCheck(res.results, application), err => this.applicationService.handleError(err));
      }
    } else {
      this.analyticsService.track(
        'HRA Application',
        'Dashboard',
        'Stop',
        'Continue application, sending to additional property',
        '/additional-prop/additional',
        this.additionalAnalyticsDetails());
      this.router.navigate(['/additional-prop/additional']);
    }
  }

  onPropertyListCheck(response: any, application: Application) {
    if (application.RentalAppStatus.toUpperCase() !== 'DRAFT' && application.RentalAppStatus.toUpperCase() !== 'WAIT LIST') {
      localStorage.removeItem('RentalApplicationKey');
      this.analyticsService.track(
        'HRA Application',
        'Dashboard',
        'Stop',
        'Application status is good, sending to documents',
        '/application/documents',
        this.additionalAnalyticsDetails());
      this.router.navigate(['/application/documents']);
    }
    else if (!response) {
      this.errorMessage = 'We’re sorry, but information about this property cannot be fetched right now. Please call our customer service center for assistance.';
      this.errorService.showError(this.errorMessage)
    }
    else if (!this.checkIfPropertyAvailable(response)) {
      this.errorMessage = 'We’re sorry, but this home is no longer available. Please return to our ' +
        'website or call our customer service center for assistance in finding a new home to apply your application to.';
      this.errorService.showError(this.errorMessage);
    }
    else if (application.RentalAppStatus === 'WAIT LIST') {
      this.applicationService.checkPropertyWaitList(application.RentalApplicationKey, false)
        .subscribe(res => this.onContinueWaitListCheck(res, application), err => this.applicationService.handleError(err));
    } else {
      this.applicationService.continueApplication(application.RentalApplicationKey)
        .subscribe(res => this.onContinueApplication(res), err => this.applicationService.handleError(err));
    }
  }

  onContinueApplication(application: Application) {
    localStorage.setItem('RentalApplicantKey', application.CurrentUserApplicantKey.toString());
    location.href = '/application/basic';
  }

  onContinueWaitListCheck(res: boolean, application: Application) {
    if (res == false) {
      this.applicationService.continueApplication(application.RentalApplicationKey)
        .subscribe(res => this.onContinueApplication(res), err => this.applicationService.handleError(err));
    }
    else {
      localStorage.removeItem('RentalApplicationKey');
      this.analyticsService.track(
        'HRA Application',
        'Dashboard',
        'Stop',
        'Sending to documents',
        '/application/documents',
        this.additionalAnalyticsDetails());
      this.router.navigate(['/application/documents']);
    }
  }

  checkIfPropertyAvailable(response: any) {
    if (Array.isArray(response) && response.length > 0) {
      const postStatus = response[0].post_status;

      if (postStatus !== "publish") {
        return false;
      }
      else {
        return true;
      }
    }

    return false;
  }
}
